import React from "react";

import BaseViewHTML from "./BaseViewHTML";

export default ({ proposal, employees }) => {
  return <BaseViewHTML proposal={proposal} employees={employees} />
};
